// source: pbtypes/gen/skybus_tunnel/fec_tunnel_stats.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

goog.exportSymbol('proto.skybus_tunnel.FecTunnelStats', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.skybus_tunnel.FecTunnelStats = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.skybus_tunnel.FecTunnelStats, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.skybus_tunnel.FecTunnelStats.displayName = 'proto.skybus_tunnel.FecTunnelStats';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.skybus_tunnel.FecTunnelStats.prototype.toObject = function(opt_includeInstance) {
  return proto.skybus_tunnel.FecTunnelStats.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.skybus_tunnel.FecTunnelStats} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skybus_tunnel.FecTunnelStats.toObject = function(includeInstance, msg) {
  var f, obj = {
utime: jspb.Message.getFieldWithDefault(msg, 1, 0),
channelId: jspb.Message.getFieldWithDefault(msg, 6, 0),
sourceChunks: jspb.Message.getFieldWithDefault(msg, 2, 0),
recoveryChunks: jspb.Message.getFieldWithDefault(msg, 3, 0),
totalChunks: jspb.Message.getFieldWithDefault(msg, 4, 0),
droppedChunks: jspb.Message.getFieldWithDefault(msg, 5, 0),
unrecoveredFrames: jspb.Message.getFieldWithDefault(msg, 7, 0),
recoveredFrames: jspb.Message.getFieldWithDefault(msg, 8, 0),
totalFrames: jspb.Message.getFieldWithDefault(msg, 9, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.skybus_tunnel.FecTunnelStats}
 */
proto.skybus_tunnel.FecTunnelStats.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.skybus_tunnel.FecTunnelStats;
  return proto.skybus_tunnel.FecTunnelStats.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.skybus_tunnel.FecTunnelStats} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.skybus_tunnel.FecTunnelStats}
 */
proto.skybus_tunnel.FecTunnelStats.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readSint64());
      msg.setUtime(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readSint32());
      msg.setChannelId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setSourceChunks(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setRecoveryChunks(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setTotalChunks(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setDroppedChunks(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setUnrecoveredFrames(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setRecoveredFrames(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setTotalFrames(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.skybus_tunnel.FecTunnelStats.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.skybus_tunnel.FecTunnelStats.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.skybus_tunnel.FecTunnelStats} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skybus_tunnel.FecTunnelStats.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUtime();
  if (f !== 0) {
    writer.writeSint64(
      1,
      f
    );
  }
  f = message.getChannelId();
  if (f !== 0) {
    writer.writeSint32(
      6,
      f
    );
  }
  f = message.getSourceChunks();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getRecoveryChunks();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getTotalChunks();
  if (f !== 0) {
    writer.writeUint32(
      4,
      f
    );
  }
  f = message.getDroppedChunks();
  if (f !== 0) {
    writer.writeUint32(
      5,
      f
    );
  }
  f = message.getUnrecoveredFrames();
  if (f !== 0) {
    writer.writeUint32(
      7,
      f
    );
  }
  f = message.getRecoveredFrames();
  if (f !== 0) {
    writer.writeUint32(
      8,
      f
    );
  }
  f = message.getTotalFrames();
  if (f !== 0) {
    writer.writeUint32(
      9,
      f
    );
  }
};


/**
 * optional sint64 utime = 1;
 * @return {number}
 */
proto.skybus_tunnel.FecTunnelStats.prototype.getUtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.skybus_tunnel.FecTunnelStats} returns this
 */
proto.skybus_tunnel.FecTunnelStats.prototype.setUtime = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional sint32 channel_id = 6;
 * @return {number}
 */
proto.skybus_tunnel.FecTunnelStats.prototype.getChannelId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.skybus_tunnel.FecTunnelStats} returns this
 */
proto.skybus_tunnel.FecTunnelStats.prototype.setChannelId = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional uint32 source_chunks = 2;
 * @return {number}
 */
proto.skybus_tunnel.FecTunnelStats.prototype.getSourceChunks = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.skybus_tunnel.FecTunnelStats} returns this
 */
proto.skybus_tunnel.FecTunnelStats.prototype.setSourceChunks = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional uint32 recovery_chunks = 3;
 * @return {number}
 */
proto.skybus_tunnel.FecTunnelStats.prototype.getRecoveryChunks = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.skybus_tunnel.FecTunnelStats} returns this
 */
proto.skybus_tunnel.FecTunnelStats.prototype.setRecoveryChunks = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional uint32 total_chunks = 4;
 * @return {number}
 */
proto.skybus_tunnel.FecTunnelStats.prototype.getTotalChunks = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.skybus_tunnel.FecTunnelStats} returns this
 */
proto.skybus_tunnel.FecTunnelStats.prototype.setTotalChunks = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional uint32 dropped_chunks = 5;
 * @return {number}
 */
proto.skybus_tunnel.FecTunnelStats.prototype.getDroppedChunks = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.skybus_tunnel.FecTunnelStats} returns this
 */
proto.skybus_tunnel.FecTunnelStats.prototype.setDroppedChunks = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional uint32 unrecovered_frames = 7;
 * @return {number}
 */
proto.skybus_tunnel.FecTunnelStats.prototype.getUnrecoveredFrames = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.skybus_tunnel.FecTunnelStats} returns this
 */
proto.skybus_tunnel.FecTunnelStats.prototype.setUnrecoveredFrames = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional uint32 recovered_frames = 8;
 * @return {number}
 */
proto.skybus_tunnel.FecTunnelStats.prototype.getRecoveredFrames = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.skybus_tunnel.FecTunnelStats} returns this
 */
proto.skybus_tunnel.FecTunnelStats.prototype.setRecoveredFrames = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional uint32 total_frames = 9;
 * @return {number}
 */
proto.skybus_tunnel.FecTunnelStats.prototype.getTotalFrames = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.skybus_tunnel.FecTunnelStats} returns this
 */
proto.skybus_tunnel.FecTunnelStats.prototype.setTotalFrames = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


goog.object.extend(exports, proto.skybus_tunnel);
